(function (root) {
  "use strict";

  function uniqueIds(values) {
    var seen = Object.create(null);

    return (Array.isArray(values) ? values : []).reduce(function (ids, value) {
      var id = String(value == null ? "" : value).trim();

      if (!id || seen[id]) return ids;

      seen[id] = true;
      ids.push(id);
      return ids;
    }, []);
  }

  function mergeCandidateIds(existingIds, candidateIds, excludedIds, limit) {
    var excluded = Object.create(null);
    var maximum = Math.max(0, Number(limit) || 0);

    uniqueIds(excludedIds).forEach(function (id) {
      excluded[id] = true;
    });

    return uniqueIds([].concat(existingIds || [], candidateIds || []))
      .filter(function (id) {
        return !excluded[id];
      })
      .slice(0, maximum);
  }

  function sourceIdsForRequest(sourceIds, maximumSources) {
    var maximum = Math.max(0, Number(maximumSources) || 0);
    return uniqueIds(sourceIds).slice(0, maximum);
  }

  root.BBRelatedProductsModel = {
    uniqueIds: uniqueIds,
    mergeCandidateIds: mergeCandidateIds,
    sourceIdsForRequest: sourceIdsForRequest,
  };
})(window);
